import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { contentListQueries } from '../../queries';
import { queryClient } from 'src/config/request';
import { handleImportContent } from './handleImportContent';
/*
 * NOTE: This hook is specifically designed to handle content imported or created outside the microfrontend
 * (e.g., in /quiz, /advertisement, or /webinar pages within the app-club-admin host app),
 * and coordinates the necessary synchronization when returning to the microfrontend
 */
export function useHandleManageHostContent() {
    const [searchParams, setSearchParams] = useSearchParams();
    useEffect(function handleManageHostContent() {
        async function syncContent() {
            const moduleId = searchParams.get('moduleId');
            const pageId = searchParams.get('pageId');
            const extra = searchParams.get('extra');
            const arrivedFrom = searchParams.get('arrivedFrom');
            if (!arrivedFrom)
                return;
            const newParams = new URLSearchParams(searchParams);
            if (pageId && moduleId) {
                queryClient.invalidateQueries(contentListQueries.getPages(moduleId));
            }
            if (moduleId) {
                queryClient.invalidateQueries(contentListQueries.getModules({ extra: Boolean(extra) }));
            }
            if (arrivedFrom === 'importContent') {
                const latestModuleId = await handleImportContent(extra);
                if (latestModuleId) {
                    newParams.set('moduleId', latestModuleId);
                }
            }
            newParams.delete('arrivedFrom');
            setSearchParams(newParams);
        }
        syncContent();
    }, [searchParams, setSearchParams]);
}
